import React from 'react';
import PropTypes from 'prop-types';
// Import contexts
import { useFormContext } from 'react-hook-form';

const DateInput = ({
  autoComplete,
  dateType,
  defaultValue,
  fieldValidation,
  onChange,
  name,
  maxLength,
}) => {
  const { errors } = useFormContext();
  const inputName = name + dateType;

  return (
    <>
      <label className="ds-fe-label" htmlFor={inputName}>
        {dateType}
      </label>
      <input
        autoComplete={autoComplete}
        className={`ds-fe-input ${errors[name] ? 'ds-fe-input--error' : ''}`}
        defaultValue={defaultValue}
        id={inputName}
        inputMode="numeric"
        onChange={onChange}
        name={inputName}
        ref={fieldValidation}
        type="text"
        maxLength={parseInt(maxLength, 10)} // Parse the string to an integer
      />
    </>
  );
};

DateInput.propTypes = {
  autoComplete: PropTypes.string,
  dateType: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  fieldValidation: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  maxLength: PropTypes.string,
};

DateInput.defaultProps = {
  autoComplete: null,
  defaultValue: '',
  fieldValidation: null,
  maxLength: 4,
};

export default DateInput;
